<div class="rd-widget widget-{{widgetConfig?.widgetId}}" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="34" class="widget-grid-column widget-header-red" style="text-align: start;">
            <widget-value class="widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">Miscellaneous Revenue</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>

    <tbody>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="golden-line-widget-table">
          <td colspan="8" class="bold"></td>
          <td colspan="2" class="bold align-right"><label>{{'miscRevenue.lineItemActual1' | rdTranslate}}</label></td>
          <td colspan="2" class="bold align-right"><label>{{'miscRevenue.lineItemActual2' | rdTranslate}}</label></td>
          <td colspan="2" class="bold align-right"><label>{{'miscRevenue.lineItemActual3' | rdTranslate}}</label></td>
          <td colspan="2" class="bold align-right"><label>{{'miscRevenue.lineItemMonths' | rdTranslate}}</label></td>
          <td colspan="4" class="bold align-right"><label>{{'miscRevenue.lineItemAnnulized' | rdTranslate}}</label></td>
          <td colspan="4" class="bold align-right"><label>{{'miscRevenue.lineItemBudget' | rdTranslate}}</label></td>
          <td colspan="5" class="bold align-right"><label>{{'miscRevenue.labelJll' | rdTranslate}}</label></td>
          <td colspan="5" class="bold align-right"><label>{{'miscRevenue.labelJll' | rdTranslate}}</label></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="3" [widget]="this">
        <tr class="golden-line-widget-table">
          <td colspan="8" class="bold"><label>{{'miscRevenue.lineItem' | rdTranslate}}</label></td>
          <td colspan="2" class="bold"><widget-value [align]="'right'">{{ widgetData.actual1YearLabel | rdYearQuarter:'':4}}</widget-value></td>
          <td colspan="2" class="bold"><widget-value [align]="'right'">{{ widgetData.actual2YearLabel | rdYearQuarter:'':4}}</widget-value></td>
          <td colspan="2" class="bold"><widget-value [align]="'right'">{{ widgetData.actual3YearLabel | rdYearQuarter:'':4}}</widget-value></td>
          <td colspan="2" class="bold"><widget-value [align]="'right'">{{ widgetData.actualMonthLabel | rdYearQuarter:'':4}}</widget-value></td>
          <td colspan="4" class="bold"><widget-value [align]="'right'">{{ widgetData.actualMonthLabel | rdYearQuarter:'':4}}</widget-value></td>
          <td colspan="4" class="bold"><widget-value [align]="'right'">{{ widgetData.actualMonthLabel | rdYearQuarter:'':4}}</widget-value></td>
          <td colspan="5" class="bold align-right"><label>{{'miscRevenue.lineItemProjection1' | rdTranslate}}</label></td>
          <td colspan="5" class="bold align-right"><label>{{'miscRevenue.lineItemProjection2' | rdTranslate}}</label></td>
        </tr>
      </dynamic-growth-row>
      <ng-container *ngFor="let row of widgetData.rows; let i = index">
        <dynamic-growth-row [row]="4 + i" [widget]="this">
          <tr>
            <td colspan="8"><widget-value [align]="'left'"></widget-value>{{ row.lineItem }}</td>
            <td colspan="2"><widget-value [align]="'right'">{{ row.lineItemActual1 | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
            <td colspan="2"><widget-value [align]="'right'">{{ row.lineItemActual2 | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
            <td colspan="2"><widget-value [align]="'right'">{{ row.lineItemActual3 | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
            <td colspan="2"><widget-value [align]="'right'">{{ row.lineItemMonths | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
            <td colspan="4"><widget-value [align]="'right'">{{ row.lineItemAnnulized | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
            <td colspan="4"><widget-value [align]="'right'">{{ row.lineItemBudget | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
            <td colspan="5"><widget-value [align]="'right'">{{ row.lineItemProjection1 | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
            <td colspan="5"><widget-value [align]="'right'">{{ row.lineItemProjection2 | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
    </tbody>
  </table>
</div>
